import { observable, action, runInAction, makeAutoObservable } from "mobx";
import agent from "../api/agent";
import { RootStore } from "./rootStore";
import { toast } from "react-toastify";
import {
  IFilter,
  getFilter,
  IDocumentFilterResponse,
  IResendMailForm,
  IDocumentList,
} from "../models/trackDocument";
import { IList } from "../models/listOfValours";
import {
  getDocumentType,
  getProcessResultCode,
  getEmailStateAcquirer,
} from "../util/listOfValoursOptions";
import { getDateFormatDDMMAAAA } from "../util/dateOptions";
import { ProcessResultCode } from "../util/GeneralEnums";
import { showError } from "../util/errorTypeEnumsOptions";

export default class TrackDocumentStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    makeAutoObservable(this);
    this.rootStore = rootStore;
  }

  @observable acquirersAutocomplete: IList[] = [
    { key: `sinFiltro`, text: `Sin Filtro`, value: "" },
  ];
  @observable documentNumberAutocomplete: IList[] = [
    { key: `sinFiltro`, text: `Sin Filtro`, value: "" },
  ];
  @observable dianNumberAutocomplete: IList[] = [
    { key: `sinFiltro`, text: `Sin Filtro`, value: "" },
  ];
  @observable btFilter = false;
  @observable documents: IDocumentFilterResponse = {
    documentList: null,
    length: 0,
  };
  @observable paginationSize: number = 5;
  @observable page: number = 1;
  @observable pageSize: number = 30;
  @observable filter: IFilter = {
    acquirerIdentification: "",
    documentNumber: "",
    documentType: -1,
    processState: -1,
    dianNumber: "",
    emailStateAcquirer: -1,
    documentDateFrom: null,
    documentDateTo: null,
    receptionDateFrom: null,
    receptionDateTo: null,
    sortBy: undefined,
    sortDirection: undefined,
  };
  @observable loadData = false;
  @observable acordionFilterState = false;

  @action clearFilter = () => {
    this.filter = {
      acquirerIdentification: "",
      documentNumber: "",
      documentType: -1,
      processState: -1,
      dianNumber: "",
      emailStateAcquirer: -1,
      documentDateFrom: null,
      documentDateTo: null,
      receptionDateFrom: null,
      receptionDateTo: null,
      sortBy: undefined,
      sortDirection: undefined,
    };
    this.documents = {
      documentList: null,
      length: 0,
    };
    this.paginationSize = 5;
    this.page = 1;
    this.pageSize = 30;
  };

  @action setDetailReject = (documentDateFrom: Date, documentDateTo: Date) => {
    this.filter = {
      acquirerIdentification: "",
      documentNumber: "",
      dianNumber: "",
      documentType: -1,
      processState: ProcessResultCode.SendSuccessRejected,
      emailStateAcquirer: -1,
      documentDateFrom: documentDateFrom,
      documentDateTo: documentDateTo,
      receptionDateFrom: null,
      receptionDateTo: null,
      sortBy: undefined,
      sortDirection: undefined,
    };
  };
  @action searchDocById = (id: string) => {
    return this.documents.documentList.find((doc) => doc.id === id);
  };
  @action changeAcordionFilterState = () => {
    this.acordionFilterState = !this.acordionFilterState;
  };
  @action changeStatebtFilter = () => {
    this.btFilter = !this.btFilter;
  };
  @action changePageSize = (pageSize: number) => {
    this.pageSize = pageSize;
    this.getTrackDocuments();
  };
  @action changePage = (page: number) => {
    this.page = page;
    this.getTrackDocuments();
  };
  @action setFilter = (filter: IFilter) => {
    this.filter = filter;
    this.changePage(1);
  };

  @action setSorting = (column: string) => {
    if (this.filter.sortBy === column) {
      this.filter.sortDirection = this.filter.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.filter.sortBy = column;
      this.filter.sortDirection = 'asc';
    }
    this.changePage(1);
  };

  @action getAcquirersAutocomplete = async (search: string) => {
    if (search === "") {
      runInAction(() => {
        this.acquirersAutocomplete = [
          { key: `sinFiltro`, text: `Sin Filtro`, value: "" },
        ];
      });
    }
    try {
      const check = await agent.TrackDocuments.getAcquirersAutocomplete(search);
      runInAction(() => {
        this.acquirersAutocomplete = [
          { key: `sinFiltro`, text: `Sin Filtro`, value: "" },
        ];
        check.map((us) => {
          this.acquirersAutocomplete.push({
            key: `${us.identification}${us.name}`,
            text: `${us.identification}-${us.name}`,
            value: `${us.identification}`,
          });
        });
      });
    } catch (error) {}
  };

  //
  @action getDianNumberAutocomplete = async (search: string) => {
    if (search === "") {
      runInAction(() => {
        this.dianNumberAutocomplete = [
          { key: `sinFiltro`, text: `Sin Filtro`, value: "" },
        ];
      });
    }

    try {
      const check = await agent.TrackDocuments.getDianNumberAutocomplete(
        search
      );
      runInAction(() => {
        this.dianNumberAutocomplete = [
          { key: `sinFiltro`, text: `Sin Filtro`, value: "" },
        ];
        check.map((dian: any) => {
          this.dianNumberAutocomplete.push({
            key: `${dian}`,
            text: `${dian}`,
            value: `${dian}`,
          });
        });
      });
    } catch (error) {}
  };

  @action getDocumentNumberAutocomplete = async (search: string) => {
    if (search === "") {
      runInAction(() => {
        this.documentNumberAutocomplete = [
          { key: `sinFiltro`, text: `Sin Filtro`, value: "" },
        ];
      });
    }

    try {
      const check = await agent.TrackDocuments.getDocumentNumberAutocomplete(
        search
      );
      runInAction(() => {
        this.documentNumberAutocomplete = [
          { key: `sinFiltro`, text: `Sin Filtro`, value: "" },
        ];
        check.map((erp: any) => {
          this.documentNumberAutocomplete.push({
            key: `${erp}`,
            text: `${erp}`,
            value: `${erp}`,
          });
        });
      });
    } catch (error) {}
  };

  @action getTrackDocuments = async () => {
    this.changeStatebtFilter();
    try {
      const trackList = await agent.TrackDocuments.getTrackDocuments(
        getFilter(this.filter, this.pageSize, this.page)
      );
      runInAction(() => {
        this.documents = trackList;
      });
    } catch (error) {
      showError(error);
    }
    this.changeStatebtFilter();
    runInAction(() => {
      this.loadData = true;
      this.acordionFilterState = false;
    });
  };

  @action resendMail = async (
    values: IResendMailForm,
    document: IDocumentList
  ) => {
    this.rootStore.buttonLoadingStore.changeState();
    try {
      const r = await agent.TrackDocuments.resendMail(values, document);
      if (r.sucess) {
        toast.success("Email enviado correctamente");
        runInAction(() => {
          this.rootStore.modalStore.closeModal();
        });
      } else toast.error("Error:" + r.errorMessage);
    } catch (error) {
      showError(error);
    }
    this.rootStore.buttonLoadingStore.changeState();
  };

  @action resendBulkMail = async (
    values: IResendMailForm,
    documentsIds: string[],
  ) => {
    this.rootStore.buttonLoadingStore.changeState();
    try {
      const r = await agent.TrackDocuments.resendBulkMail(values, documentsIds);
      if (r.sucess) {
        toast.success("Emails enviados correctamente");
        runInAction(() => {
          this.rootStore.modalStore.closeModal();
        });
      } else toast.error("Error:" + r.errorMessage);
    } catch (error) {
      showError(error);
    }
    this.rootStore.buttonLoadingStore.changeState();
  };

  @action getFilterInfo = () => {
    let count = 0;
    let info = ``;
    if (
      this.filter.acquirerIdentification !== "" &&
      this.filter.acquirerIdentification !== undefined
    ) {
      info += `<div class="column filterinfoitem">Cliente: ${this.filter.acquirerIdentification}</div>`;
      count++;
    }

    if (
      this.filter.documentNumber !== "" &&
      this.filter.documentNumber !== undefined
    ) {
      info += `<div class="column filterinfoitem">No Comprobante ERP: ${this.filter.documentNumber}</div>`;
      count++;
    }

    if (this.filter.dianNumber !== "" && this.filter.dianNumber !== undefined) {
      info += `<div class="column filterinfoitem">No Comprobante DIAN: ${this.filter.dianNumber}</div>`;
      count++;
    }

    if (count === 3) {
      info += `</div><div class="row filterinforow">`;
      count = 0;
    }
    if (this.filter.processState !== -1) {
      info += `<div class="column filterinfoitem">Estado comprobante: ${getProcessResultCode(
        this.filter.processState
      )}</div>`;
      count++;
    }
    if (count === 3) {
      info += `</div><div class="row filterinforow">`;
      count = 0;
    }
    if (this.filter.emailStateAcquirer !== -1) {
      info += `<div class="column filterinfoitem">Estado mail adquiriente: ${getEmailStateAcquirer(
        this.filter.emailStateAcquirer
      )}</div>`;
      count++;
    }
    if (count === 3) {
      info += `</div><div class="row filterinforow">`;
      count = 0;
    }
    if (count === 3) {
      info += `</div><div class="row filterinforow">`;
      count = 0;
    }

    if (this.filter.documentType !== -1) {
      info += `<div class="column filterinfoitem">Tipo de comprobante: ${getDocumentType(
        this.filter.documentType
      )}</div>`;
      count++;
    }

    if (count === 3) {
      info += `</div><div class="row filterinforow">`;
      count = 0;
    }

    if ((this.filter.documentDateFrom || this.filter.documentDateTo) !== null) {
      info += `<div class="column filterinfoitem">Fecha comprobante: `;
      if (this.filter.documentDateFrom !== null) {
        info += `desde: ${getDateFormatDDMMAAAA(
          this.filter.documentDateFrom.toString()
        )} `;
      }
      if (this.filter.documentDateTo !== null) {
        info += `hasta: ${getDateFormatDDMMAAAA(
          this.filter.documentDateTo.toString()
        )}`;
      }
      info += `</div>`;
      count++;
    }
    if (count === 3) {
      info += `</div><div class="row filterinforow">`;
      count = 0;
    }
    if (
      (this.filter.receptionDateFrom || this.filter.receptionDateTo) !== null
    ) {
      info += `<div class="column filterinfoitem">Fecha recepción: `;
      if (this.filter.receptionDateFrom !== null) {
        info += `desde: ${getDateFormatDDMMAAAA(
          this.filter.receptionDateFrom.toString()
        )} `;
      }

      if (this.filter.receptionDateTo !== null) {
        info += `hasta: ${getDateFormatDDMMAAAA(
          this.filter.receptionDateTo.toString()
        )}`;
      }
      info += `</div>`;
      count++;
    }
    if (info !== "") {
      info =
        '<div class="ui three column grid filterinfocontainer"><div class="row filterinforow">' +
        info +
        `</div></div>`;
    }
    return info;
  };
}
